import { FamilyStepOption } from "@domain/product/monitoring/family/family-step-option";
import { FamilyStepDto } from "@lib/dtos/monitoring/family/family-step.dto";
import { Type } from "class-transformer";

export enum StepSelectionType {
  PICK1 = "PICK1",
  AUTO = "AUTO",
  PICK0TON = "PICK0TON",
  PICK0TO1 = "PICK0TO1",
  PICK1TON = "PICK1TON",
}

export class FamilyStep extends FamilyStepDto {
  @Type(() => FamilyStepOption)
  override options!: FamilyStepOption[];

  constructor(options: FamilyStepOption[], stepSelectionType: StepSelectionType) {
    super();
    this.options = options;
    this.stepSelectionType = stepSelectionType;
  }
}
